import React, { useState } from "react";
import toast from "react-hot-toast";
import { Upload, Loader2, ImagePlus, Info } from "lucide-react";

export default function LogoPage() {
  const [fileBlack, setFileBlack] = useState(null);
  const [fileWhite, setFileWhite] = useState(null);
  const [previewBlack, setPreviewBlack] = useState("");
  const [previewWhite, setPreviewWhite] = useState("");

  // Yerel logolar
  const logoBlackUrl = "/images/logo-black.png";
  const logoWhiteUrl = "/images/logo-white.png";

  const handleFileChange = (e, type) => {
    const f = e.target.files[0];
    if (f) {
      const reader = new FileReader();
      reader.onload = (ev) => {
        if (type === 'black') {
          setFileBlack(f);
          setPreviewBlack(ev.target.result);
        } else {
          setFileWhite(f);
          setPreviewWhite(ev.target.result);
        }
      };
      reader.readAsDataURL(f);
    }
  };

  const handleDownload = (type) => {
    const link = document.createElement('a');
    if (type === 'black' && fileBlack) {
      link.href = previewBlack;
      link.download = 'logo-black.png';
    } else if (type === 'white' && fileWhite) {
      link.href = previewWhite;
      link.download = 'logo-white.png';
    }
    link.click();
    toast.success(`Logo hazır! Bu dosyayı public/images/${type === 'black' ? 'logo-black' : 'logo-white'}.png olarak kaydedin.`);
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h2>Logo Yönetimi</h2>
          <p className="page-subtitle">
            Dark ve Light mod için logolarınızı önizleyin
          </p>
        </div>
      </div>

      {/* Bilgilendirme */}
      <div className="content-card" style={{ marginBottom: '24px', background: '#eff6ff', border: '1px solid #bfdbfe' }}>
        <div style={{ display: 'flex', gap: '12px', alignItems: 'start' }}>
          <Info size={20} style={{ color: '#3b82f6', flexShrink: 0, marginTop: '2px' }} />
          <div>
            <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#1e40af', marginBottom: '4px' }}>
              Logoları Değiştirmek İçin
            </h4>
            <p style={{ fontSize: '13px', color: '#1e40af', lineHeight: '1.6' }}>
              Logo dosyalarınızı <strong>public/images/</strong> klasörüne aşağıdaki isimlerle kaydedin:
            </p>
            <ul style={{ fontSize: '13px', color: '#1e40af', marginTop: '8px', marginLeft: '20px' }}>
              <li><code style={{ background: '#dbeafe', padding: '2px 6px', borderRadius: '4px' }}>logo-black.png</code> - Light mode için (siyah logo)</li>
              <li><code style={{ background: '#dbeafe', padding: '2px 6px', borderRadius: '4px' }}>logo-white.png</code> - Dark mode için (beyaz logo)</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="logo-page-layout">
        {/* Mevcut Logolar */}
        <div className="content-card">
          <h3 className="card-title">Mevcut Logolar</h3>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ fontSize: '13px', color: '#64748b', display: 'block', marginBottom: '8px' }}>
              Logo (Siyah - Light Mode)
            </label>
            <div className="current-logo" style={{ background: '#f8fafc' }}>
              <img 
                src={logoBlackUrl} 
                alt="Logo Black" 
                onError={(e) => {
                  e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="60" viewBox="0 0 200 60"%3E%3Ctext x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle" fill="%23cbd5e1" font-size="12"%3ELogo bulunamadı%3C/text%3E%3C/svg%3E';
                }}
              />
            </div>
          </div>
          <div>
            <label style={{ fontSize: '13px', color: '#64748b', display: 'block', marginBottom: '8px' }}>
              Logo (Beyaz - Dark Mode)
            </label>
            <div className="current-logo" style={{ background: '#1e293b' }}>
              <img 
                src={logoWhiteUrl} 
                alt="Logo White"
                onError={(e) => {
                  e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="60" viewBox="0 0 200 60"%3E%3Ctext x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle" fill="%23475569" font-size="12"%3ELogo bulunamadı%3C/text%3E%3C/svg%3E';
                }}
              />
            </div>
          </div>
        </div>

        {/* Logo Önizleme */}
        <div className="content-card">
          <h3 className="card-title">Logo Önizleme</h3>
          
          {/* Logo Black */}
          <div style={{ marginBottom: '24px' }}>
            <label style={{ fontSize: '14px', fontWeight: '600', display: 'block', marginBottom: '8px' }}>
              Logo (Siyah) - Light Mode İçin
            </label>
            <div className="image-upload-area">
              {previewBlack ? (
                <div className="image-preview logo-preview">
                  <img src={previewBlack} alt="Preview Black" />
                  <button
                    type="button"
                    className="remove-image"
                    onClick={() => {
                      setFileBlack(null);
                      setPreviewBlack("");
                    }}
                  >
                    ×
                  </button>
                </div>
              ) : (
                <label className="upload-placeholder" style={{ background: '#f8fafc', border: '2px dashed #cbd5e1' }}>
                  <ImagePlus size={32} />
                  <span>Siyah logo seçin</span>
                  <small>PNG veya SVG (Şeffaf arka plan)</small>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleFileChange(e, 'black')}
                    hidden
                  />
                </label>
              )}
            </div>
            {previewBlack && (
              <button
                onClick={() => handleDownload('black')}
                className="btn btn-outline"
                style={{ marginTop: '8px', width: '100%' }}
              >
                <Upload size={16} /> İndir ve public/images/logo-black.png olarak kaydet
              </button>
            )}
          </div>

          {/* Logo White */}
          <div style={{ marginBottom: '24px' }}>
            <label style={{ fontSize: '14px', fontWeight: '600', display: 'block', marginBottom: '8px' }}>
              Logo (Beyaz) - Dark Mode İçin
            </label>
            <div className="image-upload-area">
              {previewWhite ? (
                <div className="image-preview logo-preview" style={{ background: '#1e293b' }}>
                  <img src={previewWhite} alt="Preview White" />
                  <button
                    type="button"
                    className="remove-image"
                    onClick={() => {
                      setFileWhite(null);
                      setPreviewWhite("");
                    }}
                  >
                    ×
                  </button>
                </div>
              ) : (
                <label className="upload-placeholder" style={{ background: '#1e293b', border: '2px dashed #475569' }}>
                  <ImagePlus size={32} style={{ color: '#e2e8f0' }} />
                  <span style={{ color: '#e2e8f0' }}>Beyaz logo seçin</span>
                  <small style={{ color: '#94a3b8' }}>PNG veya SVG (Şeffaf arka plan)</small>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleFileChange(e, 'white')}
                    hidden
                  />
                </label>
              )}
            </div>
            {previewWhite && (
              <button
                onClick={() => handleDownload('white')}
                className="btn btn-outline"
                style={{ marginTop: '8px', width: '100%' }}
              >
                <Upload size={16} /> İndir ve public/images/logo-white.png olarak kaydet
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
